export default __webpack_public_path__ + "static/papers-be96b7f074fb717253c006e79c2e8765.png";